import{jsx as i,jsxs as t}from"react/jsx-runtime";import{useState as a,useEffect as e}from"react";import o from"styled-components";const n=o.div`
  color: #007171;
  margintop: 8px;
`,r=o.div`
  width: 100%;
  min-height: 100;
  display: flex;
  justify-content: center;
  align-items: center;
`,s=o.div`
  width: 8px;
  height: 8px;
  background: #007171;
  border-radius: 100%;
  display: inline-block;
  animation: cycleColors 0.8s infinite ease-in-out;
  margin-right: 12px;

  @keyframes cycleColors {
    0%,
    40% {
      background: #ffffff;
    }
    60%,
    100% {
      background: #007171;
    }
  }

  &:last-child: {
    margin-right: 0;
  }

  &.dot--0 {
    animation-delay: 0s;
  }
  &.dot--1 {
    animation-delay: 0.1s;
  }
  &.dot--2 {
    animation-delay: 0.2s;
  }
  &.dot--3 {
    animation-delay: 0.3s;
  }
  &.dot--4 {
    animation-delay: 0.4s;
  }
  &.dot--5 {
    animation-delay: 0.5s;
  }
`,d=({timeout:o=300,message:d="",className:m=""})=>{const[l,c]=a(!0);return e((()=>{const i=setTimeout((()=>c(!1)),o);return()=>{clearTimeout(i)}}),[o]),l?i(r,{}):t(r,{className:m,children:[d&&i(n,{children:d}),[0,1,2,3,4,5].map((t=>i(s,{className:`dot--${t}`},t)))]})};export{d as Loader};
//# sourceMappingURL=Loader.js.map
